import { render, staticRenderFns } from "./TieBack.vue?vue&type=template&id=de67b936"
import script from "./TieBack.vue?vue&type=script&lang=js"
export * from "./TieBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports